export default __webpack_public_path__ + "static/media/door_open.13a1deb3.svg";